import React, { useState, useEffect } from "react";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Grid from '@material-ui/core/Grid';
import Trash from '../../../assets/trash.png';
import Edit from '../../../assets/edit_pen.png';
import TextField from '@mui/material/TextField';

import "./ModuleItem.scss";
import ClasseItem from "./ClasseItem";
import { MenuItem } from "@mui/material";
import Button from "../../controls/buttons/Button";

function ModuleItem({ module, admin, handleEdit, handleDelete, modIndex, classEdit, classDelete, viewClass }) {

    const [expand, setExpand] = useState(false);
    const [edit, setEdit] = useState(false);
    const [moduleName, setModuleName] = useState(module.name);
    const [moduleDraft, setModuleDraft] = useState(module.draft);
    


    function totalClasses() {
        let count = 0
        let array = [...module.classList];
        array.forEach((el, index) => {
            if (!el.draft || admin) {
                count += 1;
            }
        });
        return (count)
    }

    function toggleAcordion() {
        setExpand((prev) => !prev);
    };

    function cancelEdit() {
        setModuleName(module.name);
        setModuleDraft(module.draft);
        setEdit(false)
    };

    function renderAulas() {
        let array = [...module.classList];
        let aulas = []
        array.forEach((el, index) => {
            if (!el.draft || admin) {
                aulas.push(
                    <Grid item>
                        <ClasseItem aula={el} admin={admin} modIndex={modIndex} index={index} handleEdit={classEdit} handleDelete={() => classDelete(modIndex, index)}
                            viewClass={() => viewClass(modIndex, index)} />
                    </Grid>
                )
            }
        });
        return aulas;
    }

    function editModule(){
        let newModule = {...module};
        newModule.name = moduleName;
        newModule.draft = moduleDraft;
        handleEdit(newModule,modIndex);
        setEdit(false);

    }

    function onChangeModuleName(event) {
        setModuleName(event.target.value);
    }


    return (
        <div className="accordion-container">
            <Accordion expanded={expand}>
                <>
                    <div className="module-div">
                        <div className="module-div-left">
                            <DragIndicatorIcon />
                            {edit ? <label> Editar Módulo </label> :<label> Módulo | {module.name}</label>}
                            {admin && <img src={Edit} onClick={() => setEdit(true)} />}
                            {admin && <img src={Trash} onClick={handleDelete} />}
                        </div>
                        <div className="module-div-right">
                            <label>{totalClasses()} aulas {admin && "| "}  {admin ? module.draft ? "Rascunho" : "Publicado" : ''}</label>
                            {expand ? <KeyboardArrowUpIcon onClick={() => toggleAcordion()} /> : <KeyboardArrowDownIcon onClick={() => toggleAcordion()} />}
                        </div>

                    </div>
                    {edit &&
                        <div className="module-edit">
                            <div >
                                <TextField
                                    type="text"
                                    value={moduleName}
                                    label="Nome do Módulo"
                                    name="name"
                                    id="name"
                                    className="Module-name-field"
                                    enterKeyHint="done"
                                    onChange={onChangeModuleName}
                                />
                            </div>
                            <div >
                                <TextField
                                    select className="Module-name-select"
                                    value={moduleDraft}
                                    placeholder="Nome do Módulo"
                                    name="name"
                                    id="name"
                                    enterKeyHint="done"
                                    onChange={event => setModuleDraft(event.target.value)}
                                >
                                    <MenuItem value={true}> Rascunho </MenuItem>
                                    <MenuItem value={false}> Publicado </MenuItem>
                                </TextField>
                            </div>
                            <div>
                                <div className="edit-modules-btn">

                                    <label onClick={() => editModule()}>
                                        <Button className="primary-button">
                                            <span>Salvar alterações</span>
                                        </Button>
                                    </label>
                                    <label onClick={() => cancelEdit()}>
                                        <Button className={'white-button'}>
                                            <span>Cancelar</span>
                                        </Button>
                                    </label>

                                </div>
                            </div>

                        </div>}

                </>

                <AccordionDetails>
                    {renderAulas()}
                </AccordionDetails>
            </Accordion>
        </div>


    );
}

export default ModuleItem;
